import { css, html, LitElement } from 'lit';
import '../Inputbox/Input';
import '../AttachmentBox/AttachmentBox';
import './MentionUserList'; // Import the new mention user list component
import { formatMessageDateFromTimestamp } from '../../../utils/getFomattedDate';
import '../../Components/MessageBubble/LinkMessageBubble/LinkMessageBubble';
import { debounce } from '../../../lib/helpers';
import RecordRTC from 'recordrtc';
import 'emoji-picker-element';

class TestFooter extends LitElement {
  constructor() {
    super();
    this.isAttachmentMenuVisible = false;
    this.inputBorderColor = 'transparent';
    this.inputBorderWidth = '1px';
    this.inputBorderStyle = 'dashed';
    this.inputPlaceholder = 'Type a message';
    this.sendButtonIcon = 'https://flexcrew.s3.us-west-1.amazonaws.com/Group_1171280804_28e21ab22f.svg';
    this.attachmentIcon = 'https://isometrik-website-bucket.s3.ap-south-1.amazonaws.com/attachment_top_svgrepo_com_8c3f5013f3.svg';
    this.attachmentIconHeight = '34px';
    this.attachmentIconWidth = '34px';
    this.sendButtonIconHeight = '50px';
    this.sendButtonIconWidth = '50px';
    this.sendButtonIconRadius = '50%';
    this.inputBgColor = 'var(--bg-message-input-color)';
    this.inputFontSize = '16px';
    this.containerPadding = '10px';
    this.containerBoxShadow = '0px -4px 4px 0px #DCDDDE40;';
    this.inputBorderRadius = '10px';
    this.inputContainerBorderColor = '#D4D8EB';
    this.inputContainerBorderWidth = '1px';
    this.inputContainerBorderRadius = '10px';
    this.inputContainerBorderStyle = 'solid';
    this.inputPlaceholderColor = 'var(--text-last-seen)';
    this.inputContainerPadding = '5px 10px';
    this.onSendClick = null;
    this.backgroundColor = '#fff';

    this.audioContext = null;
    this.audioInput = null;
    this.audioRecorder = null;
    this.audioProcessor = null;
    this.audioChunks = [];
    this.mp3Encoder = null;
    this.sampleRate = 44100;
    this.mp3Data = [];
    this.audioBlob = null;
    this.audioUrl = null;
    this.isRecording = false;
    this.isPaused = false;
    this.recordingTime = 0;
    this.recordingTimeInterval = null;
    this.recorder = null;
    this.stream = null;

    // New mention-related properties
    this.showMentionList = false;
    this.mentionSearchQuery = '';
    this.lastInputValue = '';
    this.cursorPosition = 0;
    this.detectLinks = true;
    this.linkPreview = '';
    this.linkToPreview = '';
    this.debouncedCheckLinks = debounce(this.checkLinks.bind(this), 500);
    this.linkHidePreview = false;
  }

  static properties = {
    // ... existing properties ...
    inputBorderColor: { type: String },
    inputBorderWidth: { type: String },
    inputBorderStyle: { type: String },
    inputPlaceholder: { type: String },
    inputBgColor: { type: String },
    inputFontSize: { type: String },
    inputFontColor: { type: String },
    inputBorderRadius: { type: String },
    attachmentIcon: { type: String },
    sendButtonIcon: { type: String },
    micButtonIcon: { type: String },
    deleteIcon: { type: String },
    pauseIcon: { type: String },
    playIcon: { type: String },
    sendButtonIconHeight: { type: String },
    sendButtonIconWidth: { type: String },
    attachmentIconHeight: { type: String },
    attachmentIconWidth: { type: String },
    sendButtonIconRadius: { type: String },
    containerPadding: { type: String },
    containerBoxShadow: { type: String },
    inputContainerBorderColor: { type: String },
    inputContainerBorderWidth: { type: String },
    inputContainerBorderRadius: { type: String },
    inputPlaceholderColor: { type: String },
    inputContainerPadding: { type: String },
    isAttachmentMenuVisible: { type: Boolean },
    onSendClick: { type: Function },
    inputValue: { type: String },
    onMediaIconClick: { type: Function },
    onDocumentClick: { type: Function },
    onFileUploaded: { type: Function },
    backgroundColor: { type: String },
    replyMessage: { type: Object },
    handleremoveReplyMessage: { type: Function },
    onCameraClick: { type: Function },
    conversationDetails: { type: Object },
    userMetaData: { type: Object },

    // New mention-related properties
    showMentionList: { type: Boolean },
    mentionSearchQuery: { type: String },
    cursorPosition: { type: Number },

    detectLinks: { type: Boolean },
    linkPreview: { type: String },
    linkToPreview: { type: String },
    linkHidePreview: { type: Boolean },

    // Audio recording related properties
    isRecording: { type: Boolean },
    isPaused: { type: Boolean },
    recordingTime: { type: Number },
    audioBlob: { type: Object },
    audioUrl: { type: String },
    selectedConversationId: { type: String },
    handleDirectAudioUpload: { type: Function },
    // Emoji picker related properties
  };

  static styles = css`
    * {
      box-sizing: border-box;
    }

    .emoji-container {
      position: relative;
      cursor: pointer;
      z-index: 99;
    }

      emoji-picker {
      position: absolute;
      bottom: 60px;
      left: 0;
      z-index: 1001;
      --background: var(--bg-primary-color);
      --category-emoji-size: 1.5rem;
      --emoji-size: 1.5rem;
      --num-columns: 8;
      --border-color: var(--bg-primary-light);
      width: 100%;
      display: none;  
      --border-radius: 10px;
      --num-columns: 18;
      --emoji-size: 32px;
      --input-padding: 10px;
      --input-border-size: 0;
      --input-font-color: var(--text-primary-color);
      --input-border-radius: 10px;
      --button-hover-background: var(--bg-primary-light);
      --button-active-background: var(--bg-primary-light);
      --category-emoji-size: 32px;
      --indicator-color: var(--text-primary-color);
    }

  @media screen and (max-width: 768px) {
  emoji-picker {
    --num-columns: 6;
      --category-emoji-size: 20px;
      --emoji-size: 20px;
      --input-padding: 5px;
  }
}

    .footer-container {
      display: flex;
      align-items: end;
      gap: 10px;
      position: relative;
    }

    .footer-content-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
      position: relative;
    }

    .input-container {
      flex: 1;
      display: flex;
      align-items: center;
      position: relative;
    }

    .custom-reply-block {
      width: 100%;
      border-radius: 0 10px 10px 0;
      background: var(--bg-secondary-color);
      z-index: 2;
      border-left: 5px solid var(--base-color);
    }

    .attachment-container {
      width: fit-content;
      margin-right: 10px;
      cursor: pointer;
      user-select: none;
    }

    .input-box-container {
      width: 100%;
      position: relative;
    }

    .send-container {
      width: fit-content;
    }

    .focused-input {
      border: none !important;
      outline: none !important;
    }

    .attachment-menu {
      position: absolute;
      background-color: var(--bg-primary-color);
      bottom: 60px;
      left: 0px;
      box-shadow: var(--menu-shadow);
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-radius: 10px;
    }

    attachment-box {
      margin: 12px;
      overflow: hidden;
    }

    .attachment-container svg {
      opacity: 1;
      transition:
        transform 0.3s ease,
        opacity 0.2s ease;
      pointer-events: none;
    }

    .attachment-container svg.close-svg {
      transform: rotate(0deg);
      background-color: var(--bg-secondary-color);
      border-radius: 50%;
      padding: 4px;
    }

    .attachment-container svg.add-svg {
      transform: rotate(0deg);
    }

    .attachment-container svg.close-svg.rotating {
      transform: rotate(180deg);
    }

    .attachment-container svg.add-svg.rotating {
      transform: rotate(180deg);
    }

    .link-preview-loading {
      padding: 12px;
      text-align: center;
      color: #666;
      background-color: var(--bg-secondary-color);
      border-radius: 8px;
    }

    .hide {
      display: none;
    }

    .attachemnt-backdrop {
      top: 0;
      left: 26%;
      right: 0;
      bottom: 8%;
      z-index: 99;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    @keyframes fadeOut {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }

    @media (max-width: 768px) {
      .attachemnt-backdrop {
        top: 0;
        left: 5%;
        right: 0;
        bottom: 8%;
        z-index: 99;
      }
    }

    .recording-container {
      display: flex;
      align-items: center;
      justify-content: end;
      width: 40%;
      padding: 10px;
      border-radius: 10px;
      animation: fadeIn 0.3s ease;
    }

    .recording-info {
      display: flex;
      align-items: center;
      gap: 10px;
      color: var(--text-primary-color);
    }

    .recording-time {
      font-size: 16px;
      font-weight: 500;
      min-width: 70px;
    }

    .recording-controls {
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .recording-control-btn {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--bg-primary-light, #e4e6eb);
      cursor: pointer;
      transition: all 0.2s ease;
    }

    .recording-control-btn:hover {
      background-color: var(--bg-secondary-color, #d8dadf);
    }

    .pulsing-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #ff4b4b;
      animation: pulse 1.5s infinite;
    }
      .link-preview-wrapper{
      width: 95%;
      }

    @keyframes pulse {
      0% {
        transform: scale(0.8);
        opacity: 0.7;
      }
      50% {
        transform: scale(1);
        opacity: 1;
      }
      100% {
        transform: scale(0.8);
        opacity: 0.7;
      }
    }
  `;

  toggleAttachmentMenu() {
    this.isAttachmentMenuVisible = !this.isAttachmentMenuVisible;
    if (this.inputValue) {
      this.dispatchEvent(
        new CustomEvent('input-change', {
          detail: { value: '' },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  async clearLinkPreview() {
    this.linkPreview = null;
    this.linkToPreview = null;
    this.requestUpdate();
    return new Promise(resolve => {
      requestAnimationFrame(() => {
        // Double-check values are cleared
        this.linkPreview = null;
        this.linkToPreview = null;
        this.requestUpdate();
        resolve(true);
      });
    });
  }
  updated(changedProperties) {
    if (changedProperties.has('selectedConversationId')) {
      this.inputValue = '';
    this.lastInputValue = '';
    this.cancelRecording();
    }
  }
  async checkLinks(newValue) {
    if (this.linkHidePreview || !this.detectLinks || !newValue?.trim()) {
      this.clearLinkPreview();
      return;
    }
    const urlRegex = /https?:\/\/(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?(?:\/[^\s]*)?/gi;
    const urls = (newValue.match(urlRegex) || []).filter(url => {
      try {
        const parsedUrl = new URL(url.startsWith('http') ? url : `https://${url}`);

        return parsedUrl.protocol === 'https:' || (parsedUrl.protocol === 'http:' && parsedUrl.hostname.includes('.') && parsedUrl.hostname.split('.').length >= 2);
      } catch {
        return false;
      }
    });

    const lastUrl = urls[urls.length - 1];
    if (lastUrl && lastUrl !== this.linkToPreview) {
      this.linkToPreview = lastUrl;
      try {
        const fullUrl = lastUrl.startsWith('http') ? lastUrl : `https://${lastUrl}`;

        const parsedUrl = new URL(fullUrl);
        const normalizedUrl = parsedUrl.toString();
        this.linkPreview = normalizedUrl;
      } catch (error) {
        console.error('Error generating link preview:', error);
        this.clearLinkPreview();
      }

    } else if (!urls.length && !newValue?.trim()) {
      this.clearLinkPreview();
    }
    this.requestUpdate();
  }

  handleInputChange(event) {
    const newValue = event.target.value;
    this.inputValue = newValue;
    this.lastInputValue = newValue;

    // Get cursor position
    const inputElement = this.shadowRoot.querySelector('my-input');
    const textArea = inputElement?.shadowRoot.querySelector('textarea');
    if (textArea) {
      this.cursorPosition = textArea.selectionStart;
    }

    // Check for @ symbol to trigger mention list
    this.checkForMentionTrigger(newValue);
    if (!newValue.trim() || (this.linkToPreview && !newValue.includes(this.linkToPreview))) {
      if (this.debouncedCheckLinks && typeof this.debouncedCheckLinks.cancel === 'function') {
        this.debouncedCheckLinks.cancel();
      }
      this.clearLinkPreview();
    } else {
      this.debouncedCheckLinks(newValue);
    }

    // Always dispatch the mention-user event when input changes
    this.dispatchMentionEvent(newValue);
    this.dispatchEvent(
      new CustomEvent('input-change', {
        detail: { value: newValue },
        bubbles: true,
        composed: true,
      }),
    );
  }

  dispatchMentionEvent(text) {
    const mentionedUsers = this.extractMentions(text, this.conversationDetails?.members || []);

    this.dispatchEvent(
      new CustomEvent('mention-user', {
        detail: {
          value: text,
          mentionUsersList: mentionedUsers,
        },
        bubbles: true,
        composed: true,
      }),
    );
  }

  toggleEmojiPicker() {
    const emojiPicker = this.shadowRoot.querySelector('emoji-picker');
    if (emojiPicker) {
      emojiPicker.style.display = emojiPicker.style.display === 'none' ? 'block' : 'none';
    }
    this.requestUpdate();
  }

  handleEmojiSelect(event) {
    const emoji = event.detail.unicode;
    const inputElement = this.shadowRoot.querySelector('my-input');
    const textArea = inputElement?.shadowRoot.querySelector('textarea');

    if (textArea) {
      const cursorPos = textArea.selectionStart;
      const textBeforeCursor = this.inputValue.substring(0, cursorPos);
      const textAfterCursor = this.inputValue.substring(cursorPos);

      const newValue = `${textBeforeCursor}${emoji}${textAfterCursor}`;
      this.inputValue = newValue;

      this.dispatchEvent(
        new CustomEvent('input-change', {
          detail: { value: newValue },
          bubbles: true,
          composed: true,
        }),
      );

      setTimeout(() => {
        textArea.setSelectionRange(cursorPos + emoji.length, cursorPos + emoji.length);
      }, 0);
    }
  }
  
  firstUpdated() {
    document.addEventListener('click', e => {
      const emojiPicker = this.shadowRoot.querySelector('emoji-picker');
      const emojiContainer = this.shadowRoot.querySelector('.emoji-container');
      const emojiButton = emojiContainer?.querySelector('svg');

      const path = e.composedPath();
      const clickedElement = path[0];

      if (
        emojiPicker &&
        !path.includes(emojiPicker) &&
        !path.includes(emojiContainer) &&
        !path.includes(emojiButton)
      ) {
        emojiPicker.style.display = 'none';
        this.requestUpdate();
      }
    });

    const emojiPicker = this.shadowRoot.querySelector('emoji-picker');
    if (emojiPicker && emojiPicker.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        #search::placeholder {
          color: var(--text-primary-color);
          opacity: 0.7;
          font-style: italic;
        }

        #search {
         background: var(--bg-secondary-color)
        }

        #search::focus {
          outline: none;
          border: none;
          background: transparent;
        }
  
        *::-webkit-scrollbar {
          width: 5px;
          height: 8px;
        }
  
        *::-webkit-scrollbar-track {
          border-radius: 4px;
        }
  
        *::-webkit-scrollbar-thumb {
          border-radius: 4px;
        }
  
        * {
          scrollbar-width: thin;
          scrollbar-color:  var(--bg-grey-color) var(--bg-secondary-color);
        }

        .favorites {
          background: var(--bg-secondary-color) !important;
          height: 62px !important;
          align-items: center !important;
        }
      `;
      emojiPicker.shadowRoot.appendChild(style);
    }
  }

  checkForMentionTrigger(value) {
    const textBeforeCursor = value.substring(0, this.cursorPosition);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');

    if (lastAtIndex !== -1) {
      const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
      const nextChar = value.charAt(lastAtIndex + 1);

      if (lastAtIndex === textBeforeCursor.length - 1 || (!textAfterAt.includes(' ') && nextChar !== '@')) {
        this.showMentionList = true;
        this.mentionSearchQuery = textAfterAt;
        return;
      }
    }

    this.showMentionList = false;
  }

  handleUserSelect(user) {
    const textBeforeCursor = this.inputValue.substring(0, this.cursorPosition);
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    const textBeforeAt = this.inputValue.substring(0, lastAtIndex);
    const textAfterCursor = this.inputValue.substring(this.cursorPosition);

    const newValue = `${textBeforeAt}@${user.userName} ${textAfterCursor}`;
    this.inputValue = newValue;

    const newCursorPosition = lastAtIndex + user.userName.length + 2; // +2 for @ and space
    this.cursorPosition = newCursorPosition;

    this.updateInputWithMention(newValue, newCursorPosition);

    this.showMentionList = false;

    this.dispatchEvent(
      new CustomEvent('input-change', {
        detail: { value: newValue },
        bubbles: true,
        composed: true,
      }),
    );

    this.dispatchMentionEvent(newValue);
  }

  extractMentions(text, members) {
    let mentionedUsers = [];
    let order = 1;
    
    for (const member of members) {
      if (!member?.userName) continue;
      
      const mentionText = `@${member.userName}`;
      let startIndex = 0;
      
      while (true) {
        const index = text.indexOf(mentionText, startIndex);
        if (index === -1) break; // No more mentions of this user
        
        const isAtStart = index === 0 || /\s/.test(text[index - 1]);
        const endIndex = index + mentionText.length;
        const isAtEnd = endIndex >= text.length || /[\s,.!?;:]/.test(text[endIndex]);
        
        if (isAtStart && isAtEnd) {
          mentionedUsers.push({
            wordCount: member.userName.length,
            userId: member.userId,
            userName: member.userName,
            order: order++,
            position: index
          });
        }
        
        startIndex = index + 1;
      }
    }
    
    mentionedUsers.sort((a, b) => a.position - b.position);
    
    return mentionedUsers.map(({ position, ...user }) => user);
  }

  updateInputWithMention(value, cursorPos) {
    setTimeout(() => {
      const inputElement = this.shadowRoot.querySelector('my-input');
      const textArea = inputElement?.shadowRoot.querySelector('textarea');
      if (textArea) {
        textArea.value = value;
        textArea.focus();
        textArea.setSelectionRange(cursorPos, cursorPos);
      }
    }, 0);
  }

  resetInputHeight() {
    const inputElement = this.shadowRoot.querySelector('my-input');
    if (inputElement) {
      inputElement.resetHeight();
    }
  }

  fileUploadHandler(event) {
    this.onFileUploaded(event);
    this.isAttachmentMenuVisible = false;
  }

  focusInput() {
    const inputElement = this.shadowRoot.querySelector('my-input');
    if (inputElement) {
      setTimeout(() => {
        const textArea = inputElement.shadowRoot.querySelector('textarea');
        if (textArea) {
          textArea.focus();
        }
      }, 0);
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.boundHandleEnterPress = this.handleEnterPress.bind(this);
    document.addEventListener('keydown', this.boundHandleEnterPress);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Remove the event listener to prevent memory leaks
    document.removeEventListener('keydown', this.boundHandleEnterPress);
    // Cancel any pending debounced calls
    if (this.debouncedCheckLinks && typeof this.debouncedCheckLinks.cancel === 'function') {
      this.debouncedCheckLinks.cancel();
    }
    // Stop recording if active
    this.stopRecording();
    // Clear recording timer if running
    this.clearRecordingTimer();
  }

  handleEnterPress(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessageHandler();
    }
  }

  async sendMessageHandler() {
    const emojiPicker = this.shadowRoot.querySelector('emoji-picker');
    if (emojiPicker) {
      emojiPicker.style.display = 'none';
    }
    if (this.isRecording) {
      await this.stopRecording();
      await new Promise(resolve => setTimeout(resolve, 300));
      if (this.audioBlob) {
        await this.sendAudioMessage();
      } else {
        console.error('Failed to create audio blob after recording');
      }
    }else{
      if (this.debouncedCheckLinks && typeof this.debouncedCheckLinks.cancel === 'function') {
        this.debouncedCheckLinks.cancel();
      }
      this.linkToPreview = null;
      this.linkPreview = null;
      this.linkHidePreview = true;
  
      this.inputValue = '';
      this.lastInputValue = '';
  
      this.requestUpdate();
  
      this.onSendClick();
      this.resetInputHeight();
  
      await new Promise(resolve => setTimeout(resolve, 10));
      this.requestUpdate();
      setTimeout(() => {
        this.linkHidePreview = false;
        this.requestUpdate();
      }, 500);
    }
  }

  // Audio recording methods
  async startRecording() {
    try {
      try {
        const constraints = {
          audio: {
            channelCount: 2,
            deviceId: 'default'
          }
        };
        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
    } catch (error){
      alert("Error: " + error)
    }
      
      this.recorder = RecordRTC(this.stream, {
        type: 'audio',
        mimeType: 'audio/wav',
        recorderType: RecordRTC.StereoAudioRecorder,
        numberOfAudioChannels: 1,
        audioBitsPerSecond: 128000,
        timeSlice: 1000,
        disableLogs: true,
        bufferSize: 4096,
        sampleRate: 44100
      });

      // Start recording
      this.recorder.startRecording();
      
      this.isRecording = true;
      this.isPaused = false;
      this.startRecordingTimer();

      this.requestUpdate();
    } catch (error) {
      console.error('Error starting recording:', error);
      alert('Could not start recording. Please check microphone permissions.',error);
    }
  }

  pauseRecording() {
    if (this.isRecording && !this.isPaused && this.recorder) {
      this.recorder.pauseRecording();
      this.isPaused = true;
      this.clearRecordingTimer();
      this.requestUpdate();
    }
  }

  resumeRecording() {
    if (this.isRecording && this.isPaused && this.recorder) {
      this.recorder.resumeRecording();
      this.isPaused = false;
      this.startRecordingTimer();
      this.requestUpdate();
    }
  }

  async stopRecording() {
    return new Promise((resolve, reject) => {
      if (this.isRecording && this.recorder) {
        try {
          // Stop recording
          this.recorder.stopRecording(() => {
            // Get the recorded blob
            this.audioBlob = this.recorder.getBlob();
            this.audioUrl = URL.createObjectURL(this.audioBlob);

            // Stop media stream tracks
            this.stream.getTracks().forEach(track => track.stop());

            this.isRecording = false;
            this.isPaused = false;
            this.clearRecordingTimer();

            this.requestUpdate();
            resolve(this.audioBlob);
          });
        } catch (error) {
          console.error('Error stopping recording:', error);
          reject(error);
        }
      } else {
        resolve(null);
      }
    });
  }

  cancelRecording() {
    if (this.isRecording && this.recorder) {
      // Stop recording
      this.recorder.stopRecording(() => {
        // Stop media stream tracks
        if (this.stream) {
          this.stream.getTracks().forEach(track => track.stop());
        }

        this.audioBlob = null;
        this.audioUrl = null;

        this.isRecording = false;
        this.isPaused = false;
        this.recordingTime = 0;
        this.clearRecordingTimer();

        this.requestUpdate();
      });
    }
  }


  startRecordingTimer() {
    this.clearRecordingTimer();
    this.recordingTimeInterval = setInterval(() => {
      this.recordingTime += 1;
      this.requestUpdate();
    }, 1000);
  }
  clearRecordingTimer() {
    if (this.recordingTimeInterval) {
      clearInterval(this.recordingTimeInterval);
      this.recordingTimeInterval = null;
    }
  }

  formatRecordingTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  toggleAudioPlayback() {
    const audio = this.shadowRoot.querySelector('#audio-preview');
    if (audio) {
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
      this.requestUpdate();
    }
  }

  sendAudioMessage() {
    if (this.audioBlob) {
      const audioFile = new File(
        [this.audioBlob],
        `audio_${Date.now()}.webm`, // Filename with timestamp
        {
          type: this.audioBlob.type,
          lastModified: Date.now(),
        },
      );

      const audioEvent = new CustomEvent('audio-message', {
        detail: {
          files: [audioFile], // Now using File instead of Blob
          type: 'audio',
        },
        bubbles: true,
        composed: true,
      });

      this.handleDirectAudioUpload(audioFile);

      this.audioBlob = null;
      this.audioUrl = null;
      this.recordingTime = 0;
      this.mp3Data = [];
      this.requestUpdate();
    } else {
      console.error('No audio blob available to send');
    }
  }

  renderSendOrMicButton() {
    const buttonStyle = `
      width: ${this.sendButtonIconWidth};
      height: ${this.sendButtonIconHeight};
      border-width: 0px;
      border-color: var(--base-color);
      border-radius: ${this.sendButtonIconRadius};
      background-color: var(--base-color);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
    `;

    if (this.isRecording) {
      return html`
        <button style="${buttonStyle}" @click=${() => this.sendMessageHandler()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M22 2L11 13"></path>
            <path d="M22 2L15 22L11 13L2 9L22 2Z"></path>
          </svg>
        </button>
      `;
    } else if (this.inputValue && this.inputValue.trim()) {
      return html`
        <button style="${buttonStyle}" @click=${() => this.sendMessageHandler()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M22 2L11 13"></path>
            <path d="M22 2L15 22L11 13L2 9L22 2Z"></path>
          </svg>
        </button>
      `;
    } else {
      return html`
        <button style="${buttonStyle}" @click=${() => this.startRecording()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
            <line x1="12" y1="19" x2="12" y2="23"></line>
            <line x1="8" y1="23" x2="16" y2="23"></line>
          </svg>
        </button>
      `;
    }
  }

  renderRecordingControls() {
    return html`
      <div class="recording-container">
        <div class="recording-info">
          <div class="pulsing-dot"></div>
          <div class="recording-time">${this.formatRecordingTime(this.recordingTime)}</div>
        </div>
        <div class="recording-controls">
          <div class="recording-control-btn" @click="${() => this.cancelRecording()}">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
          <div class="recording-control-btn" @click="${() => (this.isPaused ? this.resumeRecording() : this.pauseRecording())}">
            ${this.isPaused
              ? html`<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>`
              : html`<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="6" y="4" width="4" height="16"></rect>
                  <rect x="14" y="4" width="4" height="16"></rect>
                </svg>`}
          </div>
        </div>
      </div>
    `;
  }

  render() {
    const isOwnMessage = this.userMetaData?.userId === this.replyMessage?.senderInfo?.userId;
    const displayName = isOwnMessage ? 'You' : this.replyMessage?.senderInfo?.userName;
    return html`
      <div style="padding: ${this.containerPadding}; box-shadow: ${this.containerBoxShadow}; background-color: ${this.backgroundColor}">
        <div class="footer-container">
          <div class="footer-content-wrapper">
            ${this.replyMessage &&
            html`
              <div class="custom-reply-block">
                <reply-block
                  .messageBody=${this.replyMessage?.body}
                  .messageInfo=${this.replyMessage}
                  .senderName=${displayName}
                  .messageTime=${formatMessageDateFromTimestamp(this.replyMessage?.sentAt)}
                  padding="10px"
                  color="var(--text-primary-color)"
                  fontSize="16px"
                  .onIconClick=${this.handleremoveReplyMessage}
                />
              </div>
            `}
            ${this.linkPreview && this.linkToPreview && this.inputValue
                ? html`
                    <div class="link-preview-wrapper ${this.linkHidePreview ? 'hide' : ''}">
                      <link-preview
                        .url=${this.linkPreview}
                        .backgroundColor=${'var(--bg-secondary-color, #f0f2f5)'}
                        .textColor=${'var(--text-primary-color)'}
                        .isShowFooter=${false}
                        .showReactionOnHover=${false}
                      ></link-preview>
                    </div>
                  `
                : null}

            <div
              class="input-container"
              style="
                padding: ${this.isRecording ? null : this.inputContainerPadding};
                justify-content: ${this.isRecording ? 'end' : 'space-between'}; "
            >
              ${this.isRecording
                ? this.renderRecordingControls()
                : html`

            <div style= '
            display:flex;
            align-items:center;
            width:100%;
            gap:10px;
            
            ' >
             <div class='emoji-container' @click="${this.toggleEmojiPicker}">
           <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="var(--text-primary-color)"><path d="M624-528.67q23.33 0 39.67-16.33Q680-561.33 680-584.67q0-23.33-16.33-39.66-16.34-16.34-39.67-16.34-23.33 0-39.67 16.34Q568-608 568-584.67q0 23.34 16.33 39.67 16.34 16.33 39.67 16.33Zm-288 0q23.33 0 39.67-16.33Q392-561.33 392-584.67q0-23.33-16.33-39.66-16.34-16.34-39.67-16.34-23.33 0-39.67 16.34Q280-608 280-584.67q0 23.34 16.33 39.67 16.34 16.33 39.67 16.33Zm144 268q66.67 0 122.17-36.5t80.5-98.16H277.33q25.67 61.66 80.84 98.16 55.16 36.5 121.83 36.5ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 333.33q139.58 0 236.46-96.87 96.87-96.88 96.87-236.46t-96.87-236.46Q619.58-813.33 480-813.33t-236.46 96.87Q146.67-619.58 146.67-480t96.87 236.46q96.88 96.87 236.46 96.87Z"/></svg>
          </div>

      
        <emoji-picker
          class="emoji-picker"
          @emoji-click="${this.handleEmojiSelect}"
        ></emoji-picker>

              ${html`
                <div class="attachment-container" @click="${this.toggleAttachmentMenu}">
                  ${this.isAttachmentMenuVisible
                    ? html`<svg
                        class="close-svg ${this.isAttachmentMenuVisible ? 'rotating' : ''}"
                        xmlns="http://www.w3.org/2000/svg"
                        height="28px"
                        viewBox="0 -960 960 960"
                        width="28px"
                        fill="var(--text-primary-color)"
                      >
                        <path
                          d="m251.33-204.67-46.66-46.66L433.33-480 204.67-708.67l46.66-46.66L480-526.67l228.67-228.66 46.66 46.66L526.67-480l228.66 228.67-46.66 46.66L480-433.33 251.33-204.67Z"
                        />
                      </svg>`
                    : html`<svg
                        class="add-svg ${!this.isAttachmentMenuVisible ? 'rotating' : ''}"
                        xmlns="http://www.w3.org/2000/svg"
                        height="32px"
                        viewBox="0 -960 960 960"
                        width="32px"
                        fill="var(--text-primary-color)"
                      >
                        <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                      </svg>`}
                </div>
              `}
               
              ${
                this.isAttachmentMenuVisible
                  ? html`
                      <div
                        class="attachemnt-backdrop"
                        @click="${() => {
                          this.isAttachmentMenuVisible = false;
                        }}"
                      >
                        <div class="attachment-menu">
                          <attachment-box
                            .flexDirection=${'column'}
                            .bgColor=${'var(--bg-primary-color)'}
                            .onMediaIconClick="${this.mediaIconHandler}"
                            .onDocumentIconClick="${this.onDocumentClick}"
                            .onFileUploaded="${this.onFileUploaded}"
                            @file-uploaded="${event => this.fileUploadHandler(event)}"
                            .onCameraClick="${this.onCameraClick}"
                          >
                          </attachment-box>
                        </div>
                      </div>
                    `
                  : ''
              }
      
              <div class='input-box-container'>
                <!-- Mention user list -->
               ${
                 this.conversationDetails?.isGroup
                   ? html` <mention-user-list
                       .users=${this.conversationDetails?.members || []}
                       .isVisible=${this.showMentionList}
                       .searchQuery=${this.mentionSearchQuery}
                       .onSelectUser=${user => this.handleUserSelect(user)}
                       .userMetaData=${this.userMetaData}
                     ></mention-user-list>`
                   : null
               }

                <my-input
                  .value="${this.inputValue}"
                  .borderColor="${this.inputBorderColor || 'gray'}"
                  .borderWidth="${this.inputBorderWidth || '1px'}"
                  .borderRadius="${this.inputBorderRadius || "10px"}"
                  .backgroundColor=${this.inputBgColor || '#ffffff'}
                  .fontSize="${this.inputFontSize || '14px'}"
                  .padding="10px"
                  .placeholder="${this.inputPlaceholder || 'Type your message'}"
                  .color=${this.inputFontColor}
                  .placeholderColor=${this.inputPlaceholderColor || '#000'}
                  .isSearchSvg=${false}
                  .disabled=${this.showCloseIcon}
                  @input="${this.handleInputChange}"
                ></my-input>
              </div>
              <div class="send-container">${this.renderSendOrMicButton()}</div>
              </div>`}
            </div>
          </div>
             ${this.isRecording ? html` <div class="send-container">${this.renderSendOrMicButton()}</div>` : null} 
        </div>
      </div>
    `;
  }

  
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('keydown', this.boundHandleEnterPress);

    // Cancel any pending debounced calls
    if (this.debouncedCheckLinks && typeof this.debouncedCheckLinks.cancel === 'function') {
      this.debouncedCheckLinks.cancel();
    }

    // Clean up audio recording resources
    this.cancelRecording();
  }
}

customElements.define('my-test-footer', TestFooter);
